@let hasDeletions =
  widgetsEc.plugins.editingPlugin.feature.selectors.hasDeletions.asSignal();

<atn-ds-page>
  <atn-ds-table [config]="widgetsTableConfig" />
</atn-ds-page>

@if (hasDeletions) {
  <atn-ds-confirmation-overlay
    title="Delete widget"
    description="Are you sure you want to delete this widget?"
    (cancel)="cancelDeletionClickHandler()"
    (confirm)="confirmDeletionClickHandler()"
  />
}
